// extracted by mini-css-extract-plugin
export default {"text":"BarItem_text__wA9im"};